<template>
    <div>
        <v-dialog v-model="dialog" max-width="600px">
            <v-card v-if="!$store.state.isLoggedIn">
                <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text">
                    <div class="font-weight-bold fill-width">
                        <span>{{ $translate('Group invite') }}</span>
                        <v-btn icon @click="dialog = false" class="float-right">
                            <v-icon class="primary primarytext--text">mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text>
                    <Login />
                <v-alert class="ma-2" type="info" dense outlined dismissible>
                    {{ $translate('You need to be logged in to join the group') }}
                </v-alert>
                </v-card-text>
            </v-card>
            <v-card v-else>
                <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text">
                    <div class="font-weight-bold fill-width">
                        <span>{{ $translate('Group invite') }}</span>
                        <v-btn icon @click="dialog = false" class="float-right">
                            <v-icon class="primary primarytext--text">mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text class="d-flex justify-space-between align-center mt-4">
                    <span>
                        <v-icon class="mr-2" color="primary">mdi-information</v-icon>
                        {{ $translate('You have been invited to the group') }} {{ groupInvite.group.name }}
                    </span>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn :loading="loading" @click="joinGroup" color="primary">
                        {{ $translate('Join group') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
  
<script>
import Login from './Login.vue'
export default {
    name: 'zoezi-group-invite-dialog',

    data: () => ({
        loading: false,
        groupInvite: {},
        dialog: false,
    }),

    components: {
        Login
    },

    watch: {
        groupInviteKey: {
            immediate: true,
            handler() {
                if (this.groupInviteKey) {
                    this.getGroupInvite(this.groupInviteKey);
                }
            },
        },
    },

    computed: {
        groupInviteKey() {
            const groupInviteQuery = this.$root.siteconfig.pages.mypagesGroupInvite || 'groupinvite';
            return this.$route.query[groupInviteQuery];
        }
    },

    methods: {
        getGroupInvite(groupInviteKey) {
            this.$api.get('/api/public/group/get_from_invite', {key: groupInviteKey}).then(group => {
                if(group?.id) {
                    if (this.$store.state.isLoggedIn && !group.users.includes(this.$store.state.user.id)) {
                        this.groupInvite = {group: group, key: groupInviteKey};
                        this.dialog = true;
                    } else if(!this.$store.state.isLoggedIn) {
                        this.groupInvite = {group: group, key: groupInviteKey};
                        this.dialog = true;
                    }
                }
            })
        },
        joinGroup() {
            this.loading = true;
            this.$api.post('/api/memberapi/group/join', null, { invitekey: this.groupInvite.key }).then((response) => {
                this.dialog = false;
                this.loading = false;
                if (!response.ok) {
                    response.json().then(data => {
                        this.$store.commit('showErrorDialog', {title: this.$translate('Error'), text: `${this.$translate('Something went wrong')} ${this.$translate(data.message)}`});
                    });
                }
            }).catch(() => {
                this.$store.commit('showSnackBar', {title: 'Error', text: 'Error accepting group invite'});
                this.loading = false;
            });
        },
    },
};
</script>
  